exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-5-wrapper[data-v-24a29c03]{width:235px;padding-bottom:10px}.bottom-label[data-v-24a29c03]{margin:50px;margin-top:10px;margin-bottom:10px;color:#fff;padding:8px;text-align:center;font-size:15px}.listing-img[data-v-24a29c03]{width:45px;height:45px;display:inline-block;margin-right:-10px;border-radius:50%;border:3px solid #fff}", ""]);

// exports
